module.exports = __webpack_public_path__ + "img/logoMini.35d83fad.svg";